(function () {
  'use strict';
  // The asset may run again after a theme-editor section reload.
  if (window.xjProductCustomizationInitialized) return;
  window.xjProductCustomizationInitialized = true;

  function sanitizeField(field) {
    if (!field || !field.closest || !field.closest('[data-xj-product-customization]')) return;
    if (field.matches('[data-xj-name]')) {
      const value = field.value.replace(/[^A-Za-z.]/g, '').slice(0, 13);
      if (field.value !== value) field.value = value;
    } else if (field.matches('[data-xj-number]')) {
      const value = field.value.replace(/[^0-9]/g, '').slice(0, 3);
      if (field.value !== value) field.value = value;
    }
  }

  function prepareForm(form) {
    const component = form && form.querySelector && form.querySelector('[data-xj-product-customization]');
    if (!component) return false;
    component.querySelectorAll('[data-xj-name], [data-xj-number]').forEach(sanitizeField);
    const quantity = component.querySelector('[name="quantity"]');
    if (quantity) {
      // Match the existing quantity selector: invalid/empty/zero => one.
      const number = Number(quantity.value);
      if (!Number.isSafeInteger(number) || number < 1) quantity.value = '1';
    }
    return true;
  }

  document.addEventListener('input', function (event) {
    if (!event.isComposing) sanitizeField(event.target);
  }, true);
  document.addEventListener('compositionend', function (event) { sanitizeField(event.target); }, true);
  document.addEventListener('change', function (event) { sanitizeField(event.target); }, true);

  // Capture runs before the theme's AJAX submit listener. Click also covers
  // native validation and accelerated-checkout controls in the same form.
  document.addEventListener('click', function (event) {
    const target = event.target;
    if (target && target.closest) prepareForm(target.closest('form'));
  }, true);
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!prepareForm(form)) return;
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.reportValidity();
    }
  }, true);
  document.addEventListener('formdata', function (event) {
    const form = event.target;
    if (!prepareForm(form)) return;
    form.querySelectorAll('[data-xj-name], [data-xj-number]').forEach(function (field) {
      event.formData.set(field.name, field.value);
    });
    const quantity = form.querySelector('[data-xj-product-customization] [name="quantity"]');
    if (quantity) event.formData.set('quantity', quantity.value);
  }, true);
}());
